import React, { useEffect, useState } from 'react'
import '../index.css'
import Logo from '../assets/logo.png'
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.js';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';



const Login = () => {
  const navigate = useNavigate();

  const {login, adminLogin,authIsLoading, errorMessage, isAuthenticated, isAdminAuthenticated} = useAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })

  const handleChange = (e) => {
    const {name, value} = e.target;
    setFormData({...formData, [name]: value});
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if(formData.type_of_user === 'admin'){
      adminLogin(formData)
    }else{
      login(formData)
    }
  }

  useEffect(() => {
    if(isAuthenticated){
      toast.success('Successfully Login', {position: "top-right", autoClose: 2000})
            setTimeout(() => {
              navigate('/dashboard')
            }, 2000)
    }
    if(isAdminAuthenticated){
      toast.success('Successfully Login', {position: "top-right", autoClose: 2000})
            setTimeout(() => {
              navigate('/admin')
            }, 2000)
    }
  }, [isAuthenticated, navigate, isAdminAuthenticated])

  useEffect(function(){
    if(errorMessage){
      toast.error(errorMessage, {position: "top-right", autoClose: 2000})
    }
  }, [errorMessage])


  return (
    <div className="login-reg-container">
          <ToastContainer />


    <div className="content-wrapper">
                <Link className="logo-container" to='/'>
       
                <img src={Logo} alt="Homify Logo" className="logo" />
          
          </Link>
      <h2>Simplify house hunting today.</h2>
      <p>PropTera is your go-to real estate platform, connecting property seekers in Lagos, Nigeria, with property owners and agents.</p>
    </div>

    <div className="form-wrapper">
      <div className="form-content">
        <h1 className='login-h1'>Sign In to PropTera</h1>
        <form id="signinForm" onSubmit={handleSubmit}>
          <div className="input-group">
            <label for="email">Email</label>
            <input onChange={handleChange} name='email' type="email" id="email" required />
          </div>
          <div className="input-group">
            <label for="password">Password</label>
            <input onChange={handleChange} type="password" name='password' id="password" required />
          </div>
          <div className="input-group">
            <label htmlFor="type_of_user">Type Of User</label>
            <select onChange={handleChange} required defaultValue="" id="type_of_user" name="type_of_user">
              <option value="" disabled>Select your type of user</option>
              <option value="user">User</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          <div className="forgot-password">
            <a href="#" id="forgotPassword">Forgot Password?</a>
          </div>
          <button  type="submit" id="sign-in">
         
            {
                authIsLoading ? 'Signing In...' : 'Sign In'
              }
            </button>
          <div className="or-divider">
            <span>OR</span>
          </div>
          {/* <div className="social-login">
            <button type="button" className="social-btn google-btn">Sign in with Google</button>
            <button type="button" className="social-btn facebook-btn">Sign in with Facebook</button>
          </div> */}
          <Link to='/register'>
            <p className="message">Don't have an account? <span style={{color:'#4CAF50'}}>
              Register
           
              </span></p>
          </Link>
  
        </form>
      </div>

    </div>
  </div>
  )
}

export default Login